import { useEffect, useState } from 'react'
import { isTokenExpired } from '../utils/auth'
import { APP_AUTH_TOKEN } from '../utils/constants'
import { useUser } from '../contexts/user.context';
import { mobilizeiConvertrService } from '../services/mobilizei/convertr.service';
import { mobilizeiUsersService } from '../services/mobilizei/users.service';
import { useOnboarding } from '../contexts/onboarding.context';
import { usePlan } from '../contexts/plan.context';
import mixpanel from 'mixpanel-browser';

export default function useAuthentication() {
    const [isLoading, setIsLoading] = useState(true)

    const [token, setToken] = useState()
    const [convertrToken, setConvertrToken] = useState()
    const { user, setUser } = useUser()

    const urlParams = new URLSearchParams(window.location.search)
    const urlToken = urlParams.get('at');
    const convertrUrlToken = urlParams.get('token');

    const localStorageToken = localStorage.getItem(APP_AUTH_TOKEN);

    const { clearOnboardingContext } = useOnboarding();
    const { clearPlanContext } = usePlan();

    const fetchUser = () => {
        if (!token) return;

        mobilizeiUsersService.getSelf()
            .then(fetchedUser => {
                setUser(fetchedUser);
                window.clarity("identify", fetchedUser.email);
                mixpanel.identify(fetchedUser.id);
            })
            .catch(() => {
                setUser(null);
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const validateConvertrToken = () => {
        if (!convertrToken) return;

        mobilizeiConvertrService.validateConvertrToken(convertrToken)
            .then(response => {
                setToken(response.token)
            })
            .catch(() => {
                setUser(null);
                setIsLoading(false)
                localStorage.removeItem(APP_AUTH_TOKEN);
            })
    }

    const logout = () => {
        // Clear user, contexts and token data
        setUser(null);
        clearOnboardingContext();
        clearPlanContext();
        localStorage.removeItem(APP_AUTH_TOKEN);
        mixpanel.reset();
    }

    useEffect(() => {
        if (token) {
            localStorage.setItem(APP_AUTH_TOKEN, token)

            //verify token validity
            const tokenExpired = isTokenExpired(token)

            //logout when token expire
            if (tokenExpired) {
                return logout();
            }

            if (!user || !user.store) {
                fetchUser()
            }
        }
    }, [token])

    useEffect(() => {
        if (convertrToken) {
            validateConvertrToken()
        }
    }, [convertrToken])


    useEffect(() => {
        // Try to get the access token from the url or the local storage
        const accessToken = urlToken || localStorageToken;
        const convertrAccessToken = convertrUrlToken;

        // Check if the access token is valid
        if(convertrAccessToken){
            setConvertrToken(convertrAccessToken);
            return;
        } else {
            if (accessToken && isTokenExpired(accessToken)) {
                logout();
            } else if (accessToken) {
                setToken(accessToken);
                return;
            }
        }

        setIsLoading(false)
    }, [])

    return {
        isAuthLoading: isLoading,
        logout,
        token,
        setToken
    }
}
